import { makeStateKey } from '@angular/core';
import { TranslationObject } from '@ngx-translate/core';

export function getTranslationStateKey(lang: string) {
  return makeStateKey<TranslationObject>(`translate-${lang}`);
}
